


export default defineNuxtPlugin((nuxtApp) => {
	nuxtApp.vueApp.config.errorHandler = (error, instance, info) => {

		console.error('[Nuxt App Error]: Capturado pelo hook vue:error', error);

	}

	nuxtApp.hook("app:error", (error) => {
		console.error('[Nuxt App Error]: Capturado pelo hook app:error', error);
	});


})